module.exports = __webpack_public_path__ + "blank_sharing_drawingwp0045715723f5808287c6c2c9a54f5d87.png";